(function (app, ng) {

    app.config([
        "figModalStateProvider", function (figModalStateProvider) {
            figModalStateProvider.state("Home.ManageStockQuestions.ConfigureStockQuestion",
                {
                    url: "/Configure/{stockQuestionId}",
                    component: "configureStockQuestion",
                    resolve: {
                        question: ["$stateParams", "stockQuestionApi", function ($stateParams, stockQuestionApi) {
                            return stockQuestionApi.getStockQuestion($stateParams.stockQuestionId);
                        }],
                        firelightQuestion: ["question", "stockQuestionApi", function (question, stockQuestionApi) {
                            return stockQuestionApi.getFirelightQuestion(question.FirelightQuestionId);
                        }],
                        rightBridgeQuestion: ["question", "stockQuestionApi", function (question, stockQuestionApi) {
                            return stockQuestionApi.getRightBridgeQuestion(question.RightBridgeQuestionId);
                        }]
                    }
                });
        }
    ]);

    app.component("configureStockQuestion",
        {
            controller: configureStockQuestionController,
            templateUrl: "/App/Dashboard/ManageStockQuestions/ConfigureStockQuestions/template.html",
            bindings: {
            }
        });

    configureStockQuestionController.$inject = ["$state", "$mdDialog"];

    function configureStockQuestionController($state, $mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isClosing: false,
                    isSaving: false,
                    CurrentView: 0
                },
                close: close,
                navToConfigStockQ: navToConfigStockQ,
                navToConfigStockQPlugins: navToConfigStockQPlugins,
                onSave: onSave,
                save: save,
                description: description
            });

        function navToConfigStockQ() {
            $ctrl.UI.CurrentView = 0;
        }

        function navToConfigStockQPlugins() {
            $ctrl.UI.CurrentView = 1;
        }

        function close() {
            $ctrl.UI.isClosing = true;
            $mdDialog.hide().then(function () { $ctrl.UI.isClosing = false; });
        }

        function description(view) {
            switch (view) {
                case 0: return "Edit Stock Question?";
                case 1: return "Setup Vendor Plugin Information";

                default: return "";
            }
        }

        function onSave(func) {
            var onSaveFunc = function () { };
            onSaveFunc = function () {
                $ctrl.UI.isSaving = true;

                return func().then(function () {
                    $ctrl.UI.isSaving = false;
                });
            };
        }

        function save() { onSaveFunc(); }

    }

})(window.app, window.angular); //jshint ignore:line